export default function () {
  try {
    if (window.xr) {
      var recordings = Array.from(xr.global.recordingContexts.keys());
      if (recordings.length > 0) {
        var context = xr.global.recordingContexts.get(recordings[0]);
        if (context.appKey && context.recordingId && context.isRecording) {
          return {
            appKey: context.appKey,
            recordingId: context.recordingId
          };
        }
      }
    }
  } catch (ex) {}
}